import { apiClient } from './api-client';

export interface EmailConfig {
  provider: 'SMTP' | 'SENDGRID' | 'MAILGUN' | 'SES' | 'ZEPTOMAIL';
  smtpHost?: string;
  smtpPort?: number;
  smtpSecure?: boolean;
  smtpUser?: string;
  smtpPassword?: string;
  sendgridApiKey?: string;
  mailgunApiKey?: string;
  mailgunDomain?: string;
  zeptomailApiKey?: string;
  sesAccessKey?: string;
  sesSecretKey?: string;
  sesRegion?: string;
  fromEmail: string;
  fromName: string;
  replyTo?: string;
  /** When false the config is kept but not used - email falls back to the platform sender. */
  isActive?: boolean;
}

class EmailConfigService {
  private readonly basePath = '/notifications/email-config';

  async getConfig(): Promise<EmailConfig | null> {
    try {
      const response = await apiClient.get<EmailConfig | null>(this.basePath);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) return null;
      throw error;
    }
  }

  async updateConfig(config: Partial<EmailConfig>): Promise<EmailConfig> {
    const response = await apiClient.put<EmailConfig>(this.basePath, config);
    return response.data;
  }

  /** Pause or resume the config without discarding it. */
  async setActive(isActive: boolean): Promise<EmailConfig> {
    const response = await apiClient.patch<EmailConfig>(`${this.basePath}/active`, { isActive });
    return response.data;
  }

  /** Remove this organization's email configuration. 204 on success, 404 if there was none. */
  async deleteConfig(): Promise<void> {
    await apiClient.delete(this.basePath);
  }

  async testConfig(email: string): Promise<{ success: boolean; message?: string; error?: string }> {
    const response = await apiClient.post<{ success: boolean; message?: string; error?: string }>(
      `${this.basePath}/test`,
      { email },
    );
    return response.data;
  }
}

export const emailConfigService = new EmailConfigService();
